import { globalCacheRef } from "../hooks/usePageData.js";
/* Scope-sensitive compatibility caches. Credentials stay only in browser memory. */
function getSessionCacheIdentity(house) {
  try {
    const session = JSON.parse(
      sessionStorage.getItem("auth_session") || "null",
    );
    if (!session) return "guest";
    const data = session.data || {};
    return JSON.stringify([
      session.tipo,
      data.id || 0,
      house === undefined ? data.casa_id || 0 : house,
      data.learning_token || data.learning_admin_token || data.token || "",
    ]);
  } catch {
    return "guest";
  }
}
function filterInstitutionRows(rows, student) {
  if (!student?.id) return rows || [];
  return (rows || []).filter(
    (row) => Number(row.institution_id) === Number(student.casa_id),
  );
}
function getPageDataCache(scope) {
  if (globalCacheRef.scope !== scope) {
    globalCacheRef.scope = scope;
    globalCacheRef.data = {};
    globalCacheRef.invalidated = new Set();
  }
  return globalCacheRef;
}
/* Reset existing React resource state before committing a different authenticated identity. */
function resetSessionResources(ref, scope, setters) {
  if (ref.current === null) {
    ref.current = scope;
    return;
  }
  if (ref.current !== scope) {
    ref.current = scope;
    setters.forEach((set) => set([]));
  }
}
export {
  getSessionCacheIdentity,
  filterInstitutionRows,
  getPageDataCache,
  resetSessionResources,
};
